import {Inject, Injectable} from '@angular/core';
import {NavItem} from 'app/components/navigation-side-bar/navigation-side-bar.component';
import {AuthService, CurrentUser} from './auth.service';
import {AppInfo, SelectedAppService} from './current-app/selected-app.service';
import {BehaviorSubject} from 'rxjs';
import {I18NEXT_SERVICE, ITranslationService} from 'angular-i18next';
import {allItems, allItemsExperimental} from 'app/components/navigation-side-bar/navigation-side-bar.helper';

@Injectable({
    providedIn: 'root',
})
export class NavService {
    public navItems$ = new BehaviorSubject<NavItem[]>([]);
    currentApp: AppInfo | null;
    currentUser: CurrentUser;
    faqUrl: string;

    constructor(
        public auth: AuthService,
        public selectedAppService: SelectedAppService,
        @Inject(I18NEXT_SERVICE) private i18Next: ITranslationService
    ) {}

    get selectedAppInfo() {
        return this.selectedAppService.selectedAppInfo;
    }

    public init(navExpanded = false) {
        this.auth.currentUser$.subscribe(currentUser => (this.currentUser = currentUser));
        this.auth.currentFAQUrl$.subscribe(currentFAQUrl => (this.faqUrl = currentFAQUrl));
        this.selectedAppService.selectedApp$.subscribe(selectedApp => (this.currentApp = selectedApp));

        this.buildNavMenu(navExpanded);
    }

    public buildNavMenu(navExpanded: boolean) {
        const mapItem = item => {
            item.target = item.target || '_self';
            item.secure = item.secure || false;
            item.exactMatch = item.exactMatch || false;
            item.link = item.link.replace(':appId', this.currentApp?.id);

            if (item.children) {
                item.children = item.children.filter(child => child.visible).map(mapItem);
                if (item.children.length === 1) {
                    return item.children[0];
                }
            }
            return item;
        };

        if (this.currentUser) {
            const navItems = this.currentUser.permissions.canViewExperimentalFrontend
                ? allItemsExperimental(this.currentUser, this.selectedAppInfo, this.faqUrl, navExpanded, this.i18Next.language)
                      .filter(item => item.visible)
                      .map(mapItem)
                : allItems(this.currentUser, this.selectedAppInfo, this.faqUrl, navExpanded, this.i18Next.language)
                      .filter(item => item.visible)
                      .map(mapItem);

            this.navItems$.next(navItems);
        }
    }
}
